export default {
    Login: {
        site_region:'global',
        site_country:'global',
        site_brand:	'HSBC',
        page_business_line: 'GBM',
        page_customer_group: 'Business',
        page_channel:'Web',
        page_url: '/dart/buyer portal/login/enter username and password',
        page_name: 'dart : buyer portal : login : enter username and password',
        page_language: '',
        page_type: 'authentication',
        page_category: 'buyer portal',
        page_subcategory: 'login',
        funnel_name: 'buyer portal - login',
        funnel_step: '1',
        funnel_step_name: 'start - username and password',
    },
    passwordreset_username: {
        site_region:'global',
        site_country:'global',
        site_brand:	'HSBC',
        page_business_line: 'GBM',
        page_customer_group: 'Business',
        page_channel:'Web',
        page_url: '/dart/buyer portal/login/forgotten password-username',
        page_name: 'dart : buyer portal : login : forgotten password - username',
        page_language: '',
        page_type: 'authentication',
        page_category: 'buyer portal',
        page_subcategory: 'login',
        funnel_name: 'buyer portal - reset password',
        funnel_step: '2',
        funnel_step_name: 'enter username',
    },
    passwordreset_security: {
        site_region:'global',
        site_country:'global',
        site_brand:	'HSBC',
        page_business_line: 'GBM',
        page_customer_group: 'Business',
        page_channel:'Web',
        page_url: '/dart/buyer portal/login/forgotten password-recovery questions',
        page_name:
            'dart : buyer portal : login : forgotten password - recovery questions',
        page_language: '',
        page_type: 'authentication',
        page_category: 'buyer portal',
        page_subcategory: 'login',
        funnel_name: 'buyer portal - reset password',
        funnel_step: '3',
        funnel_step_name: 'recovery questions',
    },
    passwordreset_new: {
        site_region:'global',
        site_country:'global',
        site_brand:	'HSBC',
        page_business_line: 'GBM',
        page_customer_group: 'Business',
        page_channel:'Web',
        page_url: '/dart/buyer portal/login/forgotten password-reset password',
        page_name:
            'dart : buyer portal : login : forgotten password - reset password',
        page_language: '',
        page_type: 'authentication',
        page_category: 'buyer portal',
        page_subcategory: 'login',
        funnel_name: 'buyer portal - reset password',
        funnel_step: '4',
        funnel_step_name: 'reset password',
    },
    passwordreset_complete: {
        site_region:'global',
        site_country:'global',
        site_brand:	'HSBC',
        page_business_line: 'GBM',
        page_customer_group: 'Business',
        page_channel:'Web',
        page_url: '/dart/buyer portal/login/forgotten password-finish',
        page_name: 'dart : buyer portal : login : forgotten password - finish',
        page_language: '',
        page_type: 'authentication',
        page_category: 'buyer portal',
        page_subcategory: 'login',
        funnel_name: 'buyer portal - reset password',
        funnel_step: '5',
        funnel_step_name: 'completed - reset finished',
    },
    recoveruser: {
        site_region:'global',
        site_country:'global',
        site_brand:	'HSBC',
        page_business_line: 'GBM',
        page_customer_group: 'Business',
        page_channel:'Web',
        page_url: '/dart/buyer portal/login/forgotten username',
        page_name: 'dart : buyer portal : login : forgotten username',
        page_language: '',
        page_type: 'authentication',
        page_category: 'buyer portal',
        page_subcategory: 'login',
    },
};



// WEBPACK FOOTER //
// ./shared/userTracking/pagetags.js